import apiHeader from '@/helpers/apiHeader';

const mrpFormService = {
    save(id, params) {
        return apiHeader.post(`request-pool/mrp/save/${id}`, params);
    },
};

export default mrpFormService;
